import React from 'react';

/**
 * Componente que muestra un ícono con tooltip de mensaje
 * @param {string} message - Mensaje a mostrar en el tooltip
 */
const MessageTooltip = ({ message, color }) => {
	var colorClass = color ? color : 'success';
	if (!message) {
		return null;
	}

	return (
		<span
		 	className={"ml-2 text-" + colorClass}
			data-tooltip="tooltip"
			data-placement="top"
			title={message}
			style={{cursor: 'pointer'}}
		>
			<i className="ft-message-square"></i>
		</span>
	);
};

export default MessageTooltip;
